var map = {
	"./icons/error.svg": 50,
	"./icons/facebook.svg": 51,
	"./icons/information.svg": 52,
	"./icons/instagram.svg": 53,
	"./icons/linkedin.svg": 54,
	"./icons/marker.svg": 55,
	"./icons/pinterest.svg": 56,
	"./icons/slider-arrow.svg": 57,
	"./icons/success.svg": 58,
	"./icons/twitter.svg": 59,
	"./icons/weibo.svg": 60,
	"./icons/youtube.svg": 61,
	"./logo.png": 62,
	"./pattern.jpg": 63,
	"./spinner.gif": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;